// Pure helpers for the shared Team Directory of professionals.
// No Firestore, no React: just the shape and the "worth logging" rule, so the
// logic is easy to unit-test. The Firestore wrapper in firebasefunctions.js
// (syncParticipantsToDirectory) performs the read-match-write using these.

// Normalize a deal participant (the "Contacts" section row) into a directory
// "pro" shape. Participants carry denormalized name/phone/email plus a `type`
// (the role, e.g. "Lender").
export function normalizePro(participant = {}) {
  return {
    name: String(participant.fullName || participant.name || "").trim(),
    email: String(participant.email || "").trim(),
    phone: String(participant.phone || "").trim(),
    role: String(participant.type || "").trim(),
    company: String(participant.company || participant.organization || "").trim(),
  };
}

// A pro is worth logging only if we can identify it: a name, plus at least one
// of email / phone.
export function isLoggablePro(pro) {
  if (!pro || !pro.name) return false;
  return !!(pro.email || pro.phone);
}
